import React from "react";

import { styled } from "@mui/material";

const Circle = styled("div")<{
  radius?: string;
  widthHeigt?: string;
}>(({ radius, widthHeigt }) => ({
  width: widthHeigt || "8px",
  height: widthHeigt || "8px",
  borderRadius: radius || "50%",
  backgroundColor: "#E98D0B",
  marginLeft: "4px",
  marginBottom: "10px",
}));

export const CircleBadge: React.FC<{
  radius?: string;
  widthHeigt?: string;
}> = ({ radius, widthHeigt }) => {
  return <Circle radius={radius} widthHeigt={widthHeigt} />;
};
